module.exports = __webpack_public_path__ + "images/branding/manpower/right_tab.gif";